import { formatDataValue } from 'utils/formatFns';

export const vehicleSummaryFields = {
  dealerCode: {
    label: 'Dealer Code',
    getValue: (data) => ({
      dealerCode: data?.generalInfo?.vehicleSummary?.wholesaleDealerCode,
      dealerName: data?.generalInfo?.vehicleSummary?.wholesaleDealerName,
    }),
    formatValue: ({ dealerCode, dealerName }) => {
      const formattedCode = formatDataValue({ value: dealerCode });
      const formattedName = formatDataValue({ value: dealerName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  dealerInvoiceDate: {
    label: 'Dealer Invoice Date',
    getValue: (data) => data?.generalInfo?.vehicleSummary?.wholesaleDealerInvoiceDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  dealerWholesaleDate: {
    label: 'Dealer Wholesale Date',
    getValue: (data) => data?.generalInfo?.vehicleSummary?.wholesaleDealerInvoiceDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  distributorInvoiceDate: {
    label: 'Distributor Invoice Date',
    getValue: (data) => data?.generalInfo?.vehicleSummary?.distributorInvoiceDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  groupDate: {
    label: 'Group Date',
    getValue: (data) => data?.generalInfo?.vehicleSummary?.groupInfo?.[0]?.groupDeleteDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  groupDateLogistics: {
    label: 'Group Date',
    getValue: (data) => data?.generalInfo?.vehicleSummary?.groupInfo[0]?.groupEstablishedDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  groupNumber: {
    label: 'Group Number',
    getValue: (data) => data?.generalInfo?.vehicleSummary?.groupNumber,
    formatValue: (value) => formatDataValue({ value }),
  },
  orderChangeEligible: {
    label: 'Order Change Eligible',
    getValue: (data) => data?.generalInfo?.vehicleSummary?.orderChangeEligibilityIndicator,
    formatValue: (value) => (value ? 'Y' : 'N'),
  },
  preventWholesale: {
    label: 'Prevent Wholesale',
    getValue: (data) => data?.generalInfo?.vehicleSummary?.preventWholesaleIndicator,
    formatValue: (value) => (value ? 'YES' : 'NO'),
  },
  retailArea: {
    label: 'Retail Area',
    getValue: (data) => ({
      regionCode: data?.generalInfo?.vehicleSummary?.retailRegionCode,
      regionName: data?.generalInfo?.vehicleSummary?.retailRegionName,
    }),
    formatValue: ({ regionCode, regionName }) => {
      const formattedCode = formatDataValue({ value: regionCode });
      const formattedName = formatDataValue({ value: regionName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  retailDealerCode: {
    label: 'Retail Dealer Code',
    getValue: (data) => ({
      dealerCode: data?.generalInfo?.vehicleSummary?.retailDealerCode,
      dealerName: data?.generalInfo?.vehicleSummary?.retailDealerName,
    }),
    formatValue: ({ dealerCode, dealerName }) => {
      const formattedCode = formatDataValue({ value: dealerCode });
      const formattedName = formatDataValue({ value: dealerName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  wholesaleArea: {
    label: 'Wholesale Area',
    getValue: (data) => ({
      regionCode: data?.generalInfo?.vehicleSummary?.wholesaleRegionCode,
      regionName: data?.generalInfo?.vehicleSummary?.wholesaleRegionName,
    }),
    formatValue: ({ regionCode, regionName }) => {
      const formattedCode = formatDataValue({ value: regionCode });
      const formattedName = formatDataValue({ value: regionName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  wholesaleDealer: {
    label: 'Wholesale Dealer',
    getValue: (data) => ({
      dealerCode: data?.generalInfo?.vehicleSummary?.wholesaleDealerCode,
      dealerName: data?.generalInfo?.vehicleSummary?.wholesaleDealerName,
    }),
    formatValue: ({ dealerCode, dealerName }) => {
      const formattedCode = formatDataValue({ value: dealerCode });
      const formattedName = formatDataValue({ value: dealerName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
};
